var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserHubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9324 26.3314C32.9475 26.2577 33.0529 26.2577 33.0679 26.3314C33.8502 30.1588 36.8413 33.1499 40.6687 33.9322C40.7424 33.9473 40.7424 34.0526 40.6687 34.0677C36.8413 34.85 33.8502 37.8411 33.0679 41.6684C33.0529 41.7422 32.9475 41.7422 32.9324 41.6684C32.1501 37.8411 29.1591 34.85 25.3317 34.0677C25.2579 34.0526 25.2579 33.9473 25.3317 33.9322C29.1591 33.1499 32.1501 30.1588 32.9324 26.3314Z",
    stroke: "#5200FF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4374 21.7521C41.5626 21.1399 42.4374 21.1399 42.5625 21.7521C42.8389 23.1043 43.8956 24.1611 45.2478 24.4374C45.86 24.5626 45.86 25.4374 45.2478 25.5625C43.8956 25.8389 42.8389 26.8956 42.5625 28.2478C42.4374 28.86 41.5626 28.86 41.4374 28.2478C41.1611 26.8956 40.1043 25.8389 38.7521 25.5625C38.1399 25.4374 38.1399 24.5626 38.7521 24.4374C40.1043 24.1611 41.1611 23.1043 41.4374 21.7521Z",
    fill: "#5200FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 42C13.0589 42 5 38.4183 5 34C5 29.5817 13.0589 26 23 26M22 21C18.6863 21 16 18.3137 16 15V11C16 7.68629 18.6863 5 22 5C25.3137 5 28 7.68629 28 11V15C28 18.3137 25.3137 21 22 21Z",
    stroke: "#202124",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHubIcon);
export default __webpack_public_path__ + "static/media/user-hub-icon.ecabeb34482bdd04659815a017338be5.svg";
export { ForwardRef as ReactComponent };